<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" @submit="submit" @close-modal="closeModal"
    modal-alignment="top" modal-size="extra-large">
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="
        selectedUrl
          ? `/accreditationtechnical/nonconformities/store/${inputs.id}`
          : `/accreditationtechnical/nonconformities/store/`
      ">

        <legend class="col-12 col-form-label text-primary pt-0 my-3" v-if="
          evalTest.file_evaluation_historical &&
          evalTest.file_evaluation_historical.length > 0
        ">
          <h5>Historico - Propuesta de designación de equipo evaluador</h5>
        </legend>
        <table class="table table-sm table-striped" v-if="
          evalTest.file_evaluation_historical &&
          evalTest.file_evaluation_historical.length > 0
        ">
          <thead>
            <tr>
              <th scope="col" class="align-middle">NOMBRE</th>
              <th scope="col" class="align-middle text-center" style="width: 25%">
                USUARIO
              </th>
              <th scope="col" class="align-middle text-center" style="width: 15%">
                FECHA
              </th>
              <th scope="col" class="align-middle text-center" style="width: 10%"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(v, i) in evalTest.file_evaluation_historical" :key="i">
              <td class="align-middle">Documento {{ i + 1 }}</td>
              <td class="align-middle text-center">
                {{ v.user ? `${v.user.first_name} ${v.user.last_name}` : "" }}
              </td>
              <td class="align-middle text-center">
                {{ v.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(v.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="evalTest.file_evaluation">
              <td class="align-middle">Propuesta del Equipo Evaluador</td>
              <td class="align-middle">
                {{ evalTest.file_evaluation.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.file_evaluation.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'file_evaluation')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <!-- <tr v-if="evalTest.proforma">
              <td class="align-middle">Proforma de Servicios</td>
              <td class="align-middle">
                {{ evalTest.proforma.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.proforma.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'proforma')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->

            <tr v-if="evalTest.sampling_plan_file">
              <td class="align-middle">Plan de Muestreo</td>
              <td class="align-middle">
                {{ evalTest.sampling_plan_file.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.sampling_plan_file.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'sampling_plan_file')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.risk_matrix">
              <td class="align-middle">Matríz de riesgos</td>
              <td class="align-middle">
                {{ evalTest.risk_matrix.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.risk_matrix.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'risk_matrix')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.report_documentary_evaluation">
              <td class="align-middle">Evaluación Documental</td>
              <td class="align-middle">
                {{ evalTest.report_documentary_evaluation.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.report_documentary_evaluation.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'report_documentary_evaluation')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.scope401">
              <td class="align-middle">Alcance de Acreditación</td>
              <td class="align-middle">
                {{ evalTest.scope401.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.scope401.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'scope401')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.first_instance_finding403">
              <td class="align-middle">
                Primera instancia informe para el cierre de hallazgos y decisión
              </td>
              <td class="align-middle">
                {{ evalTest.first_instance_finding403.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.first_instance_finding403.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'first_instance_finding403')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.request_additional_evidence">
              <td class="align-middle">Solicitud de Evidencias Adicionales</td>
              <td class="align-middle">
                {{ evalTest.request_additional_evidence.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.request_additional_evidence.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'request_additional_evidence')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.second_instance_finding403">
              <td class="align-middle">
                Segunda instancia informe para el cierre de hallazgos y decisión
              </td>
              <td class="align-middle">
                {{ evalTest.second_instance_finding403.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.second_instance_finding403.created_at | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'second_instance_finding403')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.evaluation_plan_report">
              <td class="align-middle">Plan de Evaluación</td>
              <td class="align-middle">
                {{ evalTest.evaluation_plan_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.evaluation_plan_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'evaluation_plan_report')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <!-- <tr v-if="evalTest.accepted_evaluation_plan">
              <td class="align-middle">Plan de Evaluación (Aprobado)</td>
              <td class="align-middle">{{evalTest.accepted_evaluation_plan.user.full_name}}</td>
              <td class="align-middle">{{evalTest.accepted_evaluation_plan.created_at | dateFormat}}</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'accepted_evaluation_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->

            <tr v-if="evalTest.remote_in_situ_assessment_report">
              <td class="align-middle">Informe de Evaluación InSitu/Remota</td>
              <td class="align-middle">
                {{ evalTest.remote_in_situ_assessment_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.remote_in_situ_assessment_report.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'remote_in_situ_assessment_report')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.risk_matrix505">
              <td class="align-middle">Matriz de Análisis de riesgos y programa</td>
              <td class="align-middle">{{ evalTest.reviewer.full_name }} </td>
              <td class="align-middle" v-if="evalTest.risk_matrix505">
                {{ evalTest.risk_matrix505.created_at | dateFormat}}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'risk_matrix505')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.first_instance_finding601">
              <td class="align-middle">Informe de Cierre de hallazgos - OEC</td>
              <td class="align-middle">
                {{ evalTest.first_instance_finding601.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.first_instance_finding601.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'first_instance_finding601')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.second_instance_finding601">
              <td class="align-middle">Informe de Cierre de hallazgos - OEC</td>
              <td class="align-middle">
                {{ evalTest.second_instance_finding601.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.second_instance_finding601.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'second_instance_finding601')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.third_instance_finding601">
              <td class="align-middle">Informe de Cierre de hallazgos - OEC</td>
              <td class="align-middle">
                {{ evalTest.third_instance_finding601.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.third_instance_finding601.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'third_instance_finding601')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.findings_closing_report_603_first">
              <td class="align-middle">Informe de Cierre de hallazgos 1 - Evaluador</td>
              <td class="align-middle">
                {{ evalTest.findings_closing_report_603_first.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.findings_closing_report_603_first.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'findings_closing_report_603_first')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.findings_closing_report_603_second">
              <td class="align-middle">Informe de Cierre de hallazgos 2 - Evaluador</td>
              <td class="align-middle">
                {{ evalTest.findings_closing_report_603_second.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.findings_closing_report_603_second.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'findings_closing_report_603_second')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.findings_closing_report_603_third">
              <td class="align-middle">Informe de Cierre de hallazgos 3 - Evaluador</td>
              <td class="align-middle">
                {{ evalTest.findings_closing_report_603_third.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.findings_closing_report_603_third.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'findings_closing_report_603_third')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.historical_request_additional_evidence_603">
              <td class="align-middle">Solicitud de Evidencia Adicional 1</td>
              <td class="align-middle">
                {{ evalTest.historical_request_additional_evidence_603.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.historical_request_additional_evidence_603.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'historical_request_additional_evidence_603')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.request_additional_evidence_603">
              <td class="align-middle">Solicitud de Evidencia Adicional 2</td>
              <td class="align-middle">
                {{ evalTest.request_additional_evidence_603.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.request_additional_evidence_603.updated_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'request_additional_evidence_603')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.historical_request_additional_evidence_603_2">
              <td class="align-middle">Solicitud de Evidencia Adicional 2</td>
              <td class="align-middle">
                {{ evalTest.historical_request_additional_evidence_603_2.user.full_name }}
              </td>
              <td class="align-middle">
                {{
                evalTest.historical_request_additional_evidence_603_2.created_at
                | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="
                  openTab(evalTest, 'historical_request_additional_evidence_603_2')
                ">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.scope_505">
              <td class="align-middle">Alcance de Acreditación</td>
              <td class="align-middle">
                {{ evalTest.scope_505.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.scope_505.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'scope_505')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="evalTest.other_record508">
              <td class="align-middle">Otro</td>
              <td class="align-middle">
                {{ evalTest.other_record508.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.other_record508.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'other_record508')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!-- <tr v-if="evalTest.testification_509_2">
              <td class="align-middle">Adicional 1</td>
              <td class="align-middle">
                {{ evalTest.testification_509_2.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.testification_509_2.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'testification_509_2')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->

            <tr v-if="evalTest.testification_509_3">
              <td class="align-middle">Adicional 2</td>
              <td class="align-middle">
                {{ evalTest.testification_509_3.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.testification_509_3.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTab(evalTest, 'testification_509_3')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <tr v-if="evalTest.testification_report">
              <td class="align-middle">Informe de Testificación</td>
              <td class="align-middle">
                {{ evalTest.testification_report.user.full_name }}
              </td>
              <td class="align-middle">
                {{ evalTest.testification_report.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success"
                  @click.prevent="openTab(evalTest, 'testification_report')">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="evalTest.other_file_505.length > 0">
          <p class="text-primary">OTROS DOCUMENTOS EN LA EVALUACIÓN IN-SITU</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="evalTest.other_file_505.length > 0">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in evalTest.other_file_505" :key="index">
              <td class="align-middle">
                {{ item.filename }}
              </td>
              <td class="align-middle text-center">
                {{
                item.annexed.user
                ? `${item.annexed.user.first_name} ${item.annexed.user.last_name}`
                : ""
                }}
              </td>
              <td class="align-middle text-center">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.annexed.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="evalTest.attendance_record.length > 0">
          <p class="text-primary">Registro de asistencia participación</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="evalTest.attendance_record.length > 0">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in evalTest.attendance_record" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--  {{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.preparation_meeting &&
          evalTest.preparation_meeting.length > 0
        ">
          <p class="text-primary">Reunion de preparacion de evaluación</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.preparation_meeting &&
          evalTest.preparation_meeting.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in evalTest.preparation_meeting" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="evalTest.evaluation_questionnaire.length > 0">
          <p class="text-primary">Cuestionario de Evaluación Técnicos</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="evalTest.evaluation_questionnaire.length > 0">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in evalTest.evaluation_questionnaire" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.expert_participation_record &&
          evalTest.expert_participation_record.length > 0
        ">
          <p class="text-primary">Informe Participación Expertos Técnicos</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.expert_participation_record &&
          evalTest.expert_participation_record.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in evalTest.expert_participation_record" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.support_management_non_conformities_403_1 &&
          evalTest.support_management_non_conformities_403_1.length > 0
        ">
          <p class="text-primary">
            Respaldo gestión de No Conformidades primera entrega
          </p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.support_management_non_conformities_403_1 &&
          evalTest.support_management_non_conformities_403_1.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.support_management_non_conformities_403_1" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.support_management_non_conformities_403_2 &&
          evalTest.support_management_non_conformities_403_2.length > 0
        ">
          <p class="text-primary">
            Respaldo gestión de No Conformidades segunda entrega
          </p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.support_management_non_conformities_403_2 &&
          evalTest.support_management_non_conformities_403_2.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.support_management_non_conformities_403_2" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.expert_participation_record_testification &&
          evalTest.expert_participation_record_testification.length > 0
        ">
          <p class="text-primary">Informe Participación Expertos Técnicos</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.expert_participation_record_testification &&
          evalTest.expert_participation_record_testification.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.expert_participation_record_testification" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.testification_evaluation_questionnaire &&
          evalTest.testification_evaluation_questionnaire.length > 0
        ">
          <p class="text-primary">Cuestionario de testificación</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.testification_evaluation_questionnaire &&
          evalTest.testification_evaluation_questionnaire.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.testification_evaluation_questionnaire" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.attendance_record_testification &&
          evalTest.attendance_record_testification.length > 0
        ">
          <p class="text-primary">Registro de asistencia de técnicos</p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.attendance_record_testification &&
          evalTest.attendance_record_testification.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in evalTest.attendance_record_testification" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.support_management_non_conformities_601_1 &&
          evalTest.support_management_non_conformities_601_1.length > 0
        ">
          <p class="text-primary">
            Respaldo gestion de No Conformidades primera entrega
          </p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.support_management_non_conformities_601_1 &&
          evalTest.support_management_non_conformities_601_1.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.support_management_non_conformities_601_1" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.support_management_non_conformities_601_2 &&
          evalTest.support_management_non_conformities_601_2.length > 0
        ">
          <p class="text-primary">
            Respaldo gestion de No Conformidades Primera Evidencia Adicional
          </p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.support_management_non_conformities_601_2 &&
          evalTest.support_management_non_conformities_601_2.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.support_management_non_conformities_601_2" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <legend v-if="
          evalTest.support_management_non_conformities_601_3 &&
          evalTest.support_management_non_conformities_601_3.length > 0
        ">
          <p class="text-primary">
            Respaldo gestion de No Conformidades Segunda Evidencia Adicional
          </p>
        </legend>
        <table class="table table-sm tamble-striped" v-if="
          evalTest.support_management_non_conformities_601_3 &&
          evalTest.support_management_non_conformities_601_3.length > 0
        ">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA DE CREACIÓN</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(
                item, index
              ) in evalTest.support_management_non_conformities_601_3" :key="index">
              <td class="align-middle">
                {{ item.path.split("/")[item.path.split("/").length - 1] }}
                <!--{{ item.file_name }} {{ index + 1 }}-->
              </td>
              <td class="align-middle">
                {{ item.user.full_name }}
              </td>
              <td class="align-middle">
                {{ item.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button type="submit" class="btn btn-success" @click.prevent="openTabFor(item.path)">
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

          <legend class="text-primary" v-if="(evalTest.extensionTime601All && evalTest.extensionTime601All.length > 0) || (evalTest.testification_509_2 && evalTest.testification_509_2.length > 0)">
            Documentación de extensión de tiempo
          </legend>
          <table class="table table-sm table-striped" v-if="(evalTest.extensionTime601All && evalTest.extensionTime601All.length > 0) || (evalTest.testification_509_2 && evalTest.testification_509_2.length > 0)">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              
              <tr v-for="(v, i) in evalTest.extensionTime601All" :key="i">
                <td class="align-middle">Extensión de tiempo evaluación</td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTabFor(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
              <tr v-for="(v, i) in evalTest.testification_509_2" :key="i">
                <td class="align-middle">Extensión de tiempo testificación</td>
                <td class="align-middle text-center">
                  {{
                      v.user
                        ? `${v.user.first_name} ${v.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ v.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success" @click.prevent="openTabFor(v.path)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          <legend class="text-primary" v-if="evalTest.evaluation_team_perf && evalTest.evaluation_team_perf.length > 0">
            Evaluaciones de desempeño del equipo evaluador
          </legend>
          <table class="table table-sm tamble-striped" v-if="evalTest.evaluation_team_perf && evalTest.evaluation_team_perf.length > 0">
            <thead>
              <tr>
                <th scope="col">TIPO</th>
                <th scope="col">NOMBRE</th>
                <th scope="col">FECHA DE CREACIÓN</th>
                <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(v, i) in evalTest.evaluation_team_perf" :key="i">
                <td class="align-middle">
                  {{ v.evaluator_type.value }}
                </td>
                <td class="align-middle">
                  {{ v.evaluator.first_name }} {{ v.evaluator.last_name }}
                </td>
                <td class="align-middle">
                  {{ v.date_performance | dateFormat }}
                </td>
                <td class="align-middle" v-if="v.evaluation_team_performance">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(v,'evaluation_team_performance')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                <td v-else>
                  Aún no se ha cargado el documento
                </td>
              </tr>
            </tbody>
          </table>

          <div class="col-12" v-if="
          evalTest.action_plan
        ">
          <legend class="text-primary">
            <p>Plan de acción - (OEC)</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="evalTest.action_plan">
                <td class="align-middle">
                  Plan de acción
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.action_plan.user
                        ? `${evalTest.action_plan.user.first_name} ${evalTest.action_plan.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.action_plan.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'action_plan')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      <div class="col-12" v-if="
          evalTest.historical512 && evalTest.historical512.length > 0
        ">
          <legend class="text-primary">
            <p>Historico de plan de acción</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(historical, i) in evalTest.historical512" :key="i">
                <td class="align-middle">
                  Plan de acción - {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      historical.user
                        ? `${historical.user.first_name} ${historical.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ historical.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest.historical512,i)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          evalTest.observation_plan_action
        ">
          <legend class="text-primary">
            <p>Correciones del plan de acción - (Evaluador Líder)</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="align-middle">
                  Correciones
                </td>
                <td class="align-middle text-center">
                  {{
                      evalTest.observation_plan_action.user
                        ? `${evalTest.observation_plan_action.user.first_name} ${evalTest.observation_plan_action.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ evalTest.observation_plan_action.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest,'observation_plan_action')">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-12" v-if="
          evalTest.historical513 && evalTest.historical513.length > 0
        ">
          <legend class="text-primary">
            <p>Historico de correciones del plan de acción</p>
          </legend>
          <table class="table table-sm table-striped">
            <thead>
              <tr>
                <th scope="col" class="align-middle">NOMBRE</th>
                <th scope="col" class="align-middle text-center" style="width: 25%">
                  USUARIO
                </th>
                <th scope="col" class="align-middle text-center" style="width: 15%">
                  FECHA
                </th>
                <th scope="col" class="align-middle text-center" style="width: 10%"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(historical, i) in evalTest.historical513" :key="i">
                <td class="align-middle">
                  Corrección del plan de acción - {{ i + 1 }}
                </td>
                <td class="align-middle text-center">
                  {{
                      historical.user
                        ? `${historical.user.first_name} ${historical.user.last_name}`
                        : ""
                  }}
                </td>
                <td class="align-middle text-center">
                  {{ historical.created_at | dateFormat }}
                </td>
                <td class="align-middle text-center">
                  <button type="submit" class="btn btn-success"
                    @click.prevent="openTab(evalTest.historical513,i)">
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

      </form>
    </template>
  </app-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "ApplicacionAddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    selectedUrl: String,
  },
  filters: {
    dateFormat: function (value) {
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "";
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {},
      modalId: "director-area-modal",
      modalTitle: this.$t("add"),
    };
  },

  created() {
    this.evalTest = this.$store.state.qualityManagement.evaluation;
    if (this.selectedUrl) {
      this.modalTitle = this.$t(
        "Especificar quien revisará las acciones correctivas y evidencias"
      );
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      var data = {};
      data["id"] = this.inputs.id;
      data["reviewer_id"] = this.inputs.reviewer_id;
      this.save(data);
      this.afterSuccess();
    },
    // afterSuccess() {
    //   this.$hub.$emit("reload-" + this.tableId);
    // },

    afterSuccessFromGetEditData(response) {
      //   if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },

    openTab(obj, fileName) {
      const w = window.open(obj[fileName].path, "_blank");
      w.focus();
    },

    openTabFor(path) {
      const w = window.open(path, "_blank");
      w.focus();
    },
  },
};
</script>
